<template lang="pug">
.custom-app-tabs-wrapper(:class="wrapperClasses")
  #tabs-container.line-height-1rem(:class="{ 'sticky-header': mastheadPresent, 'is-scrolled': isScrolled }")
    slot(name="masthead")
    ul.nav.nav-tabs(
      v-if="!hideNavTabs"
      :class="{ toggled: toggled }"
    )
      li.nav-item(
        v-for="(tab, i) in tabs"
        :key="i"
        :class="tabClasses(tab)"
        @click="selectTab(tab)"
      )
        a.nav-link(:id="tab.fullTabId")
          | {{ tab.label }}
  .header-content
    slot(name="header")
  .tab-content
    slot
</template>

<script>
export default {
  name: 'AppTabs',
  provide() {
    return { selectTab: this.selectTab };
  },
  props: {
    selectedTab: {
      type: String,
      default: '',
    },
    compact: {
      type: Boolean,
      default: false,
    },
    isScrolled: {
      type: Boolean,
      default: false,
    },
    hideNavTabs: {
      type: Boolean,
      default: false,
    },
    mastheadPresent: {
      type: Boolean,
      default: false,
    },
    toggled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change'],
  data: () => ({
    tabs: [],
  }),
  computed: {
    wrapperClasses() {
      return { 'app-tabs-switch': !this.compact };
    },
    hasSelectedTab() {
      return this.tabs.some((tab) => tab.selected);
    },
  },
  watch: {
    selectedTab(newTabId, oldTabId) {
      const newTabComponent = this.findTabById(newTabId);

      if (newTabId !== oldTabId) {
        this.selectTab(newTabComponent);
      }
    },
  },
  methods: {
    tabClasses(tab) {
      return {
        active: tab.selected,
        'has-error': tab.hasError,
      };
    },
    registerTab(tabComponent) {
      this.tabs.push(tabComponent);

      if (!this.hasSelectedTab) {
        this.selectDefaultTab();
      }
    },
    selectTab(tabComponent = null, tabId = null, tabSection = null) {
      if (!tabComponent) {
        tabComponent = this.findTabById(tabId);
      }

      tabComponent.select();
      this.$emit('change', tabComponent.tabId, tabSection);

      this.tabs.forEach((t) => {
        if (t.tabId !== tabComponent.tabId) {
          t.unselect();
        }
      });
    },
    findTabById(tabId) {
      return this.tabs.find((t) => t.tabId === tabId);
    },
    selectDefaultTab() {
      const tabToSelect = this.selectedTab ? this.findTabById(this.selectedTab) : this.tabs[0];

      if (tabToSelect) {
        this.selectTab(tabToSelect);
      }
    },
  },
};
</script>
